import { useMemo, useRef } from 'react';

import * as T from '../../../../components/Typography';
import { BasicInput } from '../../../../components/Inputs';
import { Checkbox } from 'antd';
import { MediaKeyInput } from '../../../components/MediaKeyInput';
import { Icon } from '../../../../components';
import * as S from './style';
import { string, number, boolean, array, object } from 'yup';
import { mediaTypes } from '../../../../constants';
import { useStepForm } from 'CMS/Providers/StepFormProvider';

const initialData = {
  options: [{ id: 0, option: '', isCorrect: false }],
  correctAnswer: '',
  textAudioKey: '',
  textAudio: '',
};

const SpotTheWord = () => {
  // Use useRef to keep the initial state constant across renders
  const initialRef = useRef(initialData);
  const { state, updateDataFields } = useStepForm(initialRef.current);
  const { data, validationErrs } = state;

  const options = useMemo(
    () =>
      data?.options?.map((e, i) => ({ ...e, id: i })) || initialData.options,
    [data?.options]
  );

  const add = () => {
    const maxId = Math.max(...options.map((e) => e.id), 0);
    updateDataFields({
      options: [...options, { id: maxId + 1, option: '', isCorrect: false }],
    });
  };
  const remove = (id) => {
    updateDataFields({
      options: options.filter((e) => e.id !== id),
    });
  };
  const onOptionChange = (value, id) => {
    updateDataFields({
      options: options.map((e) => {
        if (e.id !== id) return e;
        return { ...e, option: value };
      }),
    });
  };

  const onIsCorrectChange = (value, id) => {
    updateDataFields({
      options: options.map((e) => {
        if (e.id !== id) return e;
        return { ...e, isCorrect: value };
      }),
    });
  };

  return (
    <div>
      <BasicInput
        label="Explainer Text"
        value={data.textAudio}
        handleChange={(textAudio) => updateDataFields({ textAudio })}
        m={{ mt: 8 }}
      />
      <MediaKeyInput
        label={`Explainer Text file Key`}
        type={mediaTypes.TEXT_AUDIO}
        value={data.textAudioKey}
        handleChange={(textAudioKey) => updateDataFields({ textAudioKey })}
        m={{ mt: 5 }}
      />

      <BasicInput
        label="Correct answer"
        value={data.correctAnswer}
        handleChange={(correctAnswer) => updateDataFields({ correctAnswer })}
        m={{ mt: 8 }}
        helper="To be shown in the notebook"
        error={validationErrs?.correctAnswer}
      />

      <T.P mt={8} size="large" weight="bold">
        Options
      </T.P>
      {validationErrs?.options &&
        typeof validationErrs.options === 'string' && (
          <T.P mb={2} mt={2} color="error">
            {validationErrs.options}
          </T.P>
        )}

      {options.map((e, i) => {
        return (
          <>
            <BasicInput
              label="Text"
              value={e.option}
              handleChange={(value) => {
                onOptionChange(value, e.id);
              }}
              m={{ mb: 5, mt: 5 }}
              error={
                validationErrs?.options && validationErrs?.options[i]?.option
              }
            />
            <Checkbox
              checked={e.isCorrect}
              onChange={(value) =>
                onIsCorrectChange(value.target.checked, e.id)
              }
              disabled={!e.option}
            >
              correct option?
            </Checkbox>
            {options.length === 1 && i === 0 ? null : (
              <S.Button
                type="link"
                danger
                ghost
                mt={1}
                onClick={() => remove(e.id)}
                ml="auto"
              >
                <Icon icon="cross" />
              </S.Button>
            )}
          </>
        );
      })}

      <S.Button
        type="link"
        ghost
        mt={5}
        mb={5}
        onClick={add}
        disabled={options.find((e) => !e.option)}
        ml="auto"
        mr="auto"
      >
        <Icon icon="plus" /> Add Option
      </S.Button>
    </div>
  );
};

const validationSchema = {
  options: array()
    .of(
      object()
        .shape({
          id: number().required(),
          option: string().required('required field'),
          isCorrect: boolean(),
        })
        .required()
    )
    .required('you must provide options')
    .min(1, 'you must provide options')
    .test('oneCorrect', 'should select one correct answer at least', (val) => {
      return val?.filter((e) => e.isCorrect)?.length >= 1;
    }),

  correctAnswer: string().required('required field'),
  textAudioKey: string().notRequired(),
  textAudio: string().notRequired(),
};
export { validationSchema };

export default SpotTheWord;
